import { get } from 'lodash';
import { FORUM_APP_ID, MEMBERS_APP_ID } from '../constants/applications';

export const getCounter = (user, appDefinitionId, counter) => get(user, `counters[${appDefinitionId}][${counter}]`, 0);

export const getPostsCount = user => getCounter(user, FORUM_APP_ID, 'postsCount');
export const getFollowersCount = user => getCounter(user, MEMBERS_APP_ID, 'followerCount');
export const getFollowingCount = user => getCounter(user, MEMBERS_APP_ID, 'followingCount');

export const increment = count => count + 1;
export const decrement = count => count - 1;

export const updatedCounters = (user, field, updateFn) => ({
  counters: {
    [MEMBERS_APP_ID]: {
      [field]: updateFn(get(user.counters, [MEMBERS_APP_ID, field], 0)),
    },
  },
});



// WEBPACK FOOTER //
// ./app/services/counters.js